import getOwnerWindow from './getOwnerWindow';

/**
 * Get the current coordinates of the specified element relative to the
 * document, including the element's width and height.
 * @param element
 * @returns An object containing the properties top, left, width,
 * and height.
 */
export default function getOffset(element) {
  var rect = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  }; // Return zeros for disconnected and hidden elements.
  // Running getBoundingClientRect on a disconnected node is IE throws an error.

  if (!element.getClientRects().length) {
    return rect;
  } // Get document-relative position by adding viewport scroll to
  // viewport-relative getBoundingClientRect.


  var window = getOwnerWindow(element);
  var pageYOffset = window != null ? window.pageYOffset : 0;
  var pageXOffset = window != null ? window.pageXOffset : 0;
  rect = element.getBoundingClientRect();
  return {
    top: rect.top + pageYOffset,
    left: rect.left + pageXOffset,
    width: rect.width,
    height: rect.height
  };
}
//# sourceMappingURL=getOffset.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/~/@flowio/browser-helpers/dist/esm/getOffset.js
// module id = 317
// module chunks = 0 1